jQuery(function($) {
	var $html = $('html').removeClass('no-js');

	$html.deepLinks();
	$('form input[id^="your-name_"]').parent().remove();
	
	if(!$.supports.touch) {
		$('select[multiple]').multiselect();
	}

	// ADD ALL YOUR CUSTOM JS THINGS AFTER THIS LINE

	/**
	 * Header accordion in ptl partners
	 */
	$html.on({
		toggler: function() {
			/**
			 * "close" all block headers on "Lösungen"
			 */
			$(this).find('.pagecreator_posttypelist__header--location').each(function(i, e) {
				// if(i > 0) {
					$(this).nextUntil('.pagecreator_posttypelist__header--location').hide();
				// }

				$(this).find('i').remove().end().css({
					cursor: 'pointer'
				})
					.append($('<i>').attr({
						'class': 'icon icon__down' + ' icon--bold text-color--primary-brand-dark'
					}).css({
						fontSize: '2.25rem',
						position: 'absolute',
						right: '0',
						top: '50%',
						transform: 'translateY(-50%)'
					}))
					.off('click.toggler')
					.on('click.toggler', function() {
						$(this).find('i').toggleClass('icon__down icon__up');

						if($(this).next().is(':visible')) {
							$(this).nextUntil('.pagecreator_posttypelist__header--location').hide();
						}
						else {
							$(this).nextUntil('.pagecreator_posttypelist__header--location').show();
						}
					});
			});
		},
		ready: function() {
			var card = $(this).find('[data-slider]').get(0);

			if(card) {
				gridCards(card);
				$(this).find('[data-slider]').slider();
			}

			$(this).trigger('toggler');
		}
	}, '.pagecreator_posttypelist, .pagecreator_termlist')
		.find('.pagecreator_posttypelist').trigger('toggler');
	$html.on({
		ready: function() {
			$(this).find('input[type="search"]').one('focus', function() {
				var that = this;
				setTimeout(function() {
					that.selectionStart = that.selectionEnd = 10000;
				}, 0);
			}).each(function() {
				this.focus();
			});
		}
	}, '.pagecreator_filter');

	/**
	 * Map pin onclick: open accordion and scroll to
	 */
	$html.on({
		click: function(event) {
			event.preventDefault();
			anchor = $(this).attr('href');
			// console.log($(this).attr('href'));
			toggle = $html.find(anchor);
			// console.log(toggle);
			toggle.click();
			$('html, body').animate({
				scrollTop: $(anchor).offset().top - 250
			}, 500);
		}
	}, '.map-pin');
});
